<template>
  <div :class="['score-table', `score-table--${theme}`]">
    <p class="score-table__title" v-html="$translate('highestScore')" />

    <div class="score-table__table">
      <ul class="table__column">
        <li class="table__item table__item--header">{{ $translate('ranking') }}</li>
        <li
          v-for="(r) in range"
          :key="r.userId"
          :class="[ 'table__item', r.userId !== $store.state.userData.userId ? 'table__item--disable' : 'table__item--active' ]"
          v-html="r.rank"
        ></li>
      </ul>

      <span class="table__column-separator" />

      <ul class="table__column">
        <li class="table__item table__item--header">{{ $translate('score') }}</li>
        <li
          v-for="(r) in range"
          :key="r.userId"
          :class="[ 'table__item', r.userId !== $store.state.userData.userId ? 'table__item--disable' : 'table__item--active' ]"
          v-html="r.score"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableScore',

  props: {
    theme: {
      type: String,
      required: false,
      default: 'color',
    },
  },

  computed: {
    range() {
      let prev = null;
      let next = null;
      let current = null;

      const currentIndex = this.$store.state.userData.scoreRange.findIndex((c) => { // eslint-disable-line
        return c.userId === this.$store.state.userData.userId;
      });

      current = this.$store.state.userData.scoreRange[currentIndex];
      prev = this.$store.state.userData.scoreRange[currentIndex - 1] || null;
      next = this.$store.state.userData.scoreRange[currentIndex + 1] || null;

      return [prev, current, next].filter((i) => i);
    },
  },
};
</script>

<style lang="scss" scoped>
.score-table {
  text-align: center;

  &.score-table--color {
    color: $color-green;

    .table__column-separator {
      background-color: $color-green;
    }
  }

  &.score-table--white {
    color: $color-white;

    .table__column-separator {
      background-color: $color-white;
    }
  }

  &__title {
    margin-bottom: 15px;

    @extend %font-medium;
    font-weight: 800;
  }

  &__table {
    position: relative;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .table__column {
    flex: 0 0 40%;
    width: 40%;

    @extend %font-small;

    .table__item {
      line-height: 1.3;
    }

    .table__item--header {
      margin-bottom: 5px;

      font-weight: 800;
    }

    .table__item--active {
      @extend %font-medium;
      font-weight: 800;
    }

    .table__item--disable {
      opacity: 0.6;
      font-weight: 400;
    }
  }

  .table__column-separator {
    display: block;
    position: absolute;
    top: 0;
    left: 50%;
    width: 1px;
    height: 100%;
  }
}
</style>
